var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.94141 83.8634C4.04541 83.8634 4.94141 82.9674 4.94141 81.8634C4.94141 65.5534 14.5954 51.6684 29.0254 47.0934C32.4644 48.9364 36.3894 49.9844 40.5564 49.9844C44.7224 49.9844 48.6464 48.9364 52.0844 47.0954C56.3444 48.4414 60.2814 50.5744 63.7864 53.4574C64.1584 53.7634 64.6084 53.9124 65.0564 53.9124C65.6334 53.9124 66.2064 53.6634 66.6014 53.1834C67.3034 52.3304 67.1804 51.0704 66.3274 50.3694C63.2354 47.8254 59.8404 45.8014 56.2014 44.3234C61.6074 39.8244 65.0564 33.0504 65.0564 25.4844C65.0564 11.9754 54.0654 0.984375 40.5564 0.984375C27.0474 0.984375 16.0564 11.9754 16.0564 25.4844C16.0564 33.0554 19.5094 39.8344 24.9224 44.3324C10.4364 50.2814 0.941406 64.8984 0.941406 81.8634C0.941406 82.9684 1.83741 83.8634 2.94141 83.8634ZM20.0564 25.4844C20.0564 14.1804 29.2524 4.98438 40.5564 4.98438C51.8604 4.98438 61.0564 14.1804 61.0564 25.4844C61.0564 36.7884 51.8604 45.9844 40.5564 45.9844C29.2524 45.9844 20.0564 36.7884 20.0564 25.4844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.0566 55.9844C62.6826 55.9844 55.0566 63.6104 55.0566 72.9844C55.0566 82.3584 62.6826 89.9844 72.0566 89.9844C81.4306 89.9844 89.0566 82.3584 89.0566 72.9844C89.0566 63.6104 81.4306 55.9844 72.0566 55.9844ZM72.0566 85.9844C64.8886 85.9844 59.0566 80.1524 59.0566 72.9844C59.0566 65.8164 64.8886 59.9844 72.0566 59.9844C79.2246 59.9844 85.0566 65.8164 85.0566 72.9844C85.0566 80.1524 79.2246 85.9844 72.0566 85.9844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.0566 70.9844H65.0566C63.9526 70.9844 63.0566 71.8804 63.0566 72.9844C63.0566 74.0884 63.9526 74.9844 65.0566 74.9844H79.0566C80.1606 74.9844 81.0566 74.0884 81.0566 72.9844C81.0566 71.8804 80.1606 70.9844 79.0566 70.9844Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.d848b0dfdf0861007b31cf1809dd16f3.svg";
export { ForwardRef as ReactComponent };